import React from "react";
import PropTypes from "prop-types";
import { Box } from "../../boxes/Box/Box";
import { Button } from "../../buttons/Button/Button";
import classNames from "classnames";
import {
  checkIsFiveMinutesBefore,
  getDateView,
  getMonthName,
  getOrdinal,
  getTimeAsString,
} from "../../../utils";

import "./consultation-big.scss";

import mascot from "../../../assets/mascot-happy-blue.png";

const AMAZON_S3_BUCKET = `${import.meta.env.VITE_AMAZON_S3_BUCKET}`;

/**
 * CardConsultationBig
 *
 * CardConsultationBig component
 *
 * @return {jsx}
 */
export const ConsultationBig = ({
  consultation,
  classes,
  handleJoin,
  handleChange,
  handleAcceptSuggestion,
  t,
  toast,
}) => {
  const { providerName, timestamp, image, status, price } = consultation;
  const imageUrl = AMAZON_S3_BUCKET + "/" + (image || "default");

  // Only scheduled (or already finished) consultations can be joined, e.g. a pending one is still being booked
  const isJoinable = status === "scheduled" || status === "finished";
  const isLive =
    isJoinable &&
    checkIsFiveMinutesBefore(timestamp, consultation?.durationMinutes);

  const startDate = new Date(timestamp);

  const ordinal = getOrdinal(startDate?.getDate());
  const dateText = `${getDateView(startDate).slice(0, 2)}${t(ordinal)} ${t(
    getMonthName(startDate).toLowerCase()
  )}`;

  const timeText = startDate ? getTimeAsString(startDate) : "";

  return (
    <Box classes={["consultation-big", classNames(classes)].join(" ")}>
      <div>
        {isLive ? (
          <p className="small-text consultation-big__now-text">
            {t("live_text")}
          </p>
        ) : (
          <p className="small-text">
            {dateText}, {timeText}
          </p>
        )}
        <div className="consultation-big__provider-container">
          <img src={imageUrl} alt={"provider"} />
          <p className="text">{providerName}</p>
        </div>
        {status === "suggested" ? (
          <Button
            type="primary"
            size="sm"
            onClick={() =>
              handleAcceptSuggestion(consultation.consultationId, price)
            }
            label={t("accept_button_label")}
            classes="consultation-big__button"
          />
        ) : isLive ? (
          <Button
            label={t("join_button_label")}
            color="purple"
            classes="consultation-big__button"
            onClick={() => handleJoin(consultation)}
          />
        ) : (
          <div>
            <div
              className="consultation-big__edit__disabled-button-wrapper"
              onClick={() => toast.info(t("join_button_label_tooltip"))}
            >
              <Button
                label={t("join_button_label")}
                color="purple"
                classes="consultation-big__button"
                disabled
              />
            </div>
            <Button
              label={t("change_button_label")}
              type="secondary"
              color="purple"
              classes="consultation-big__button"
              onClick={() => handleChange(consultation)}
            />
          </div>
        )}
      </div>
      <img src={mascot} className="consultation-big__mascot" />
    </Box>
  );
};

ConsultationBig.propTypes = {
  /**
   * Additional classes to be added to the CardConsultation
   * */
  classes: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

ConsultationBig.defaultProps = {
  isLive: false,
  classes: "",
  handleJoin: () => {},
  handleChange: () => {},
};
